/* BMC Landing CE — buy flow for the "Scoring the Game" educator landing page
   (product scoring-the-game, template bmc-landing-ce). Loaded with
   data-cfasync="false" (external assets run on this store; inline scripts are
   killed by Rocket Loader).

   1) CART FIX (same incident class as the ad pages): a store app globally
      hijacks native /cart/add form submits. We take the click in the CAPTURE
      phase + stopImmediatePropagation, zero this page's own variant via
      /cart/update.js (re-clicks can never stack), tag the cart
      bmc_src=ce-lp, then /cart/add.js adds the main item at qty 1, then
      opens /cart. No-JS fallback: the form posts the single main item
      natively, the one shape the hijacking app tolerates.
   2) Sticky bottom bar: shown only BETWEEN the hero CTA and the pricing
      card. Plain scroll + geometry, NOT IntersectionObserver: an app on
      this store breaks IO globally (fresh observers never fire).
   3) Klaviyo / 10%-off popup killer: educators on a tuition page should not
      get the composer-store discount popup. Same policy as the other
      landing pages.
   window.__bmcLPCE marks that this ran. */
(function () {
  window.__bmcLPCE = true;
  var form = document.getElementById('bmc-ce-form');
  if (!form) return;

  var cfg = null;
  try {
    var cfgEl = document.getElementById('bmc-ce-data');
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {}
  if (!cfg || !cfg.main) return;

  // PRICE SELF-HEAL: Shopify's page cache can keep serving stale HTML for a
  // while after an admin price change (2026-08-06: $699 copies lingered after
  // the $799 change). The product JSON endpoint is always current, and cached
  // HTML still loads the CURRENT version of this asset file, so rewrite any
  // dollar amount on the page that disagrees. Heals past and future copies.
  try {
    var handle = (location.pathname.match(/\/products\/([^\/?]+)/) || [])[1];
    if (handle) fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var v = prod && prod.variants && prod.variants[0];
        if (!v) return;
        function money(cents) {
          var d = Math.round(cents) / 100;
          var s = (d % 1 === 0) ? String(Math.round(d)) : d.toFixed(2);
          return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        var price = money(v.price);
        ['.bmc-ce-ctas .bmc-ce-btn', '#bmc-ce-form button', '.bmc-ce-bar__t', '.bmc-ce-bar__btn', '.bmc-ce-price .now'].forEach(function (s) {
          var els = document.querySelectorAll(s);
          for (var i = 0; i < els.length; i++) {
            var m = els[i].textContent.match(/\$[\d,.]+/);
            if (m && m[0] !== price) els[i].textContent = els[i].textContent.replace(/\$[\d,.]+/, price);
          }
        });
        if (v.compare_at_price) {
          var was = money(v.compare_at_price);
          var w = document.querySelector('.bmc-ce-price .was');
          var wm = w && w.textContent.match(/\$[\d,.]+/);
          if (wm && wm[0] !== was) w.textContent = w.textContent.replace(/\$[\d,.]+/, was);
        }
      }).catch(function () {});
  } catch (e) {}

  var btn = form.querySelector('button[type=submit]');
  var POST = { method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' } };

  var adding = false;
  function addToCart(e) {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    if (adding) return;
    adding = true;

    var label = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Adding to cart...'; }
    function fail() { adding = false; if (btn) { btn.removeAttribute('disabled'); btn.textContent = label; } }

    // 1) zero this page's own variant so a re-click can never stack a duplicate
    var clr = new URLSearchParams();
    (cfg.zero || []).forEach(function (id) { if (id) clr.append('updates[' + id + ']', '0'); });
    clr.append('attributes[bmc_src]', cfg.src || 'ce-lp');
    fetch('/cart/update.js', Object.assign({ body: clr.toString() }, POST))
      .then(function () {
        // 2) add the program at qty 1
        var p = new URLSearchParams();
        p.append('items[0][id]', cfg.main);
        p.append('items[0][quantity]', '1');
        return fetch('/cart/add.js', Object.assign({ body: p.toString() }, POST));
      })
      .then(function (r) { if (r && r.ok) { window.location.href = '/cart'; return; } fail(); })
      .catch(fail);
  }
  if (btn) btn.addEventListener('click', addToCart, true); // capture: run before the app's handler
  form.addEventListener('submit', addToCart, true);        // Enter-key path

  // ---- Sticky bottom bar: only BETWEEN the hero CTAs and the pricing card ----
  var stickyBar = document.querySelector('.bmc-ce-bar');
  var heroCta = document.querySelector('.bmc-ce-ctas');
  var priceCard = document.querySelector('.bmc-ce-price');
  if (stickyBar && heroCta && priceCard) {
    stickyBar.style.transition = 'transform .18s ease, opacity .18s ease';
    var setBar = function (show) {
      stickyBar.style.transform = show ? 'translateY(0)' : 'translateY(115%)';
      stickyBar.style.opacity = show ? '1' : '0';
      stickyBar.style.pointerEvents = show ? 'auto' : 'none';
    };
    var vis = function (el) {
      if (!el) return false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < vh;
    };
    var evalBar = function () { setBar(!vis(heroCta) && !vis(priceCard)); };
    var pend = false;
    var onMove = function () {
      if (pend) return;
      pend = true;
      requestAnimationFrame(function () { pend = false; evalBar(); });
    };
    window.addEventListener('scroll', onMove, { passive: true });
    window.addEventListener('resize', onMove, { passive: true });
    evalBar();
  }

  // ---- Block the 10% discount / email-signup popup on this landing page ----
  function hidePopupRoot(el) {
    var top = el, hop = 0;
    while (top.parentElement && hop < 6) { var ps = getComputedStyle(top.parentElement); if (ps.position === 'fixed' || ps.position === 'absolute') top = top.parentElement; hop++; }
    if (top.closest && top.closest('.bmc-ce')) return;
    top.style.setProperty('display', 'none', 'important');
  }
  function killPromoPopups() {
    try {
      var known = document.querySelectorAll('[class*="klaviyo-form"],[class*="kl-private-reset"],[class*="kl-teaser"],[id^="klaviyo"]');
      for (var i = 0; i < known.length; i++) { if (!known[i].closest('.bmc-ce')) known[i].style.setProperty('display', 'none', 'important'); }
      var all = document.querySelectorAll('div,section,aside,dialog,form');
      for (var k = 0; k < all.length; k++) {
        var el = all[k], st = getComputedStyle(el);
        if (st.position !== 'fixed' && st.position !== 'absolute') continue;
        if ((parseInt(st.zIndex, 10) || 0) < 50) continue;
        if (el.closest('.bmc-ce') || el.offsetHeight < 60) continue;
        if (/10\s*%|10\s*percent/i.test(el.textContent || '')) hidePopupRoot(el);
      }
      document.documentElement.style.overflow = ''; if (document.body) document.body.style.overflow = '';
    } catch (e) {}
  }
  killPromoPopups();
  var kpN = 0, kpTimer = setInterval(function () { killPromoPopups(); if (++kpN > 45) clearInterval(kpTimer); }, 800); // watch ~36s
  if (window.MutationObserver) {
    var kpPending = false;
    new MutationObserver(function () { if (kpPending) return; kpPending = true; setTimeout(function () { kpPending = false; killPromoPopups(); }, 120); }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
